import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getArpScan } from 'actions/nvr';

class Arp extends Component {
  componentDidMount() {
    const { dispatch, nvr } = this.props;
    dispatch(getArpScan(nvr));
  }

  componentDidUpdate(prevProps) {
    const { dispatch, nvr } = this.props;
    if (nvr.id !== prevProps.nvr.id) {
      dispatch(getArpScan(nvr));
    }
  }

  renderRows = () => {
    const { arp } = this.props;
    const entries = Object.entries(arp.data || {});

    return entries
      .sort((a, b) => {
        const aIp = a[1] || '';
        const bIp = b[1] || '';
        return aIp.localeCompare(bIp, undefined, { numeric: true, sensitivity: 'base' });
      })
      .map(([mac, ip]) => (
        <tr key={mac}>
          <td>{ip}</td>
          <td>{mac}</td>
        </tr>
      ));
  };

  render() {
    const { arp } = this.props;
    const rows = this.renderRows();

    return (
      <table className={classNames('bp3-html-table bp3-html-table-striped bp3-interactive', { 'bp3-skeleton': !!arp.pending })}>
        <thead>
          <tr>
            <td>IP Address</td>
            <td>MAC Address</td>
          </tr>
        </thead>
        <tbody>
          {rows.length ? rows : (
            <tr>
              <td colSpan={2} className="bp3-text-muted">No ARP records found</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

Arp.propTypes = {
  nvr: PropTypes.object,
  arp: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect(state => ({
  arp: state.nvrArp,
}))(Arp);
